import { render } from "./cardDoctor.vue?vue&type=template&id=6d23bea8"
import script from "./cardDoctor.vue?vue&type=script&lang=js"
export * from "./cardDoctor.vue?vue&type=script&lang=js"

import "./cardDoctor.vue?vue&type=style&index=0&id=6d23bea8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__